// istanbul ignore file
import { z } from 'zod'
import interceptedAxios from '../../../utils/interceptedAxios'

const ZKpiConfig = z.object({
  kpiDefinitionId: z.string(),
  kpiName: z.string(),
  assetId: z.string().nullable(),
  isKpiEnabled: z.boolean(),
  isAlarmApplicable: z.boolean(),
  isAlarmEnabled: z.boolean(),
  alarmLowerLimit: z.number().nullable(),
  alarmHigherLimit: z.number().nullable(),
  alarmHigherLimitSeverity: z.number().nullable(),
  alarmLowerLimitSeverity: z.number().nullable(),
  isCustomKpi: z.boolean(),
  tenantId: z.string().nullable(),
  unit: z.string().nullable(),
  isDefaultConfig: z.boolean(),
  isTotalizer: z.boolean(),
  alarmLowerLimitStateText: z.string().nullable(),
  alarmLowerLimitTextColorId: z.string().nullable(),
  alarmLowerLimitColorName: z.string().nullable(),
  alarmLowerLimitColorValue: z.string().nullable(),
  alarmLowerLimitSeverityId: z.string().nullable(),
  alarmLowerLimitSeverityLevel: z.string().nullable(),
  alarmLowerLimitLabelId: z.string().nullable(),
  alarmLowerLimitLabelName: z.string().nullable(),
  alarmLowerLimitRecommendationText: z.string().nullable(),
  alarmHigherLimitStateText: z.string().nullable(),
  alarmHigherLimitTextColorId: z.string().nullable(),
  alarmHigherLimitColorName: z.string().nullable(),
  alarmHigherLimitColorValue: z.string().nullable(),
  alarmHigherLimitSeverityId: z.string().nullable(),
  alarmHigherLimitSeverityLevel: z.string().nullable(),
  alarmHigherLimitLabelId: z.string().nullable(),
  alarmHigherLimitLabelName: z.string().nullable(),
  alarmHigherLimitRecommendationText: z.string().nullable(),
  isLowerLimitAlarmEnabled: z.boolean().nullable(),
  isHigherLimitAlarmEnabled: z.boolean().nullable(),
  lowerLimitOperator: z.string().nullable(),
  higherLimitOperator: z.string().nullable()
})

const ZKpiApiResponse = z.object({
  error: z.boolean(),
  http_status: z.number(),
  data: z.array(ZKpiConfig)
})

export type KpiConfig = z.infer<typeof ZKpiConfig>

export async function fetchKpiConfigs (
  assetId: string,
  assetTypeId: string,
  onSuccess: (configs: KpiConfig[], httpStatus: number) => any,
  onFailure: (errorMessage: any, httpStatus: number) => any
): Promise<void> {
  const url = `/asset-config-service/api/v1/udp/tiq/commands/configuration/asset/${assetId}/kpiconfig?assetTypeId=${assetTypeId}`
  interceptedAxios
    .get(url, { timeout: 15000 })
    .then((response: any) => {
      const parseResponse = ZKpiApiResponse.safeParse(response.data)
      if (parseResponse.success) {
        if (
          parseResponse.data.data !== null &&
          parseResponse.data.data !== undefined
        ) {
          onSuccess(parseResponse.data.data, response.status)
        } else {
          onFailure(parseResponse.data.error, response.status)
        }
      } else {
        onFailure(parseResponse.error.message, response.status)
      }
    })
    .catch((error: any) => {
      onFailure(error.message, error.response.status)
    })
}
